// v2（2026-10-30・要対応ファースト）で一覧・カード・パネル・ダッシュボードが共有する小部品。
// 色は段階ではなく「いま人が動くべきか」（ティア）にだけ使う。design/handoff-README.md §2「ボタンの階層」「段階ステップ」。
import type { ReactNode } from "react";
import type { GfActionKey, GfStage } from "../../../types/gifting";
import { ACTION_META, BAR_STAGES, STAGE_NAMES } from "../../../lib/giftingRules";

export interface GfActionButtonProps {
  /** アクション（tier はここから） */
  actionKey: GfActionKey;
  /** 表示文言。省略時は ACTION_META.label（list）／cta（panel） */
  label?: ReactNode;
  /** list=一覧の小ボタン（28/24px）、panel=パネル主ボタン（40px・常に塗り。tier4 は深緑） */
  variant?: "list" | "panel";
  compact?: boolean;
  disabled?: boolean;
  title?: string;
  onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * ティア色のボタン。一覧: tier0/1 は塗り、2/3/4 は色付き白抜き、5 はテキストのみ。
 * パネル主ボタン: tier0〜3 は同色の塗り、tier4 は深緑の塗り、tier5 は出さない（呼び出し側で説明文に）。
 */
export function GfActionButton({ actionKey, label, variant = "list", compact = false, disabled, title, onClick }: GfActionButtonProps) {
  const meta = ACTION_META[actionKey];
  const text = label ?? (variant === "panel" ? meta.cta : meta.label);
  const cls = [
    "gf-abtn",
    `gf-abtn--t${meta.tier}`,
    variant === "panel" ? "gf-abtn--panel" : "gf-abtn--list",
    compact ? "is-compact" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" className={cls} disabled={disabled} title={title} onClick={onClick} data-action={actionKey}>
      {text}
    </button>
  );
}

/** 7マスの段階ステップ（色相なし。済=灰・現在=墨・未=淡）。compact は 7×4px */
export function GfSteps({ stage, compact = false, withLabel = true }: { stage: GfStage; compact?: boolean; withLabel?: boolean }) {
  return (
    <span className={`gf-steps${compact ? " is-compact" : ""}`} aria-label={`段階 ${STAGE_NAMES[stage]}`}>
      <span className="gf-steps-cells">
        {BAR_STAGES.map((s) => (
          <span key={s} className={`gf-steps-cell${s < stage ? " is-done" : s === stage ? " is-cur" : ""}`} />
        ))}
      </span>
      {withLabel && <span className="gf-steps-name">{STAGE_NAMES[stage]}</span>}
    </span>
  );
}

/** 「自動·本人フォーム」等のミニタグ（要対応の強さには影響しない） */
export function GfAutoTag({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <span className="gf-autotag" title={title}>
      {children}
    </span>
  );
}
